"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.REPORTS_ENDPOINTS = {
    getReportGroups: '/backoffice/business-intelligence/{{version}}/report-groups',
    getReport: '/backoffice/business-intelligence/{{version}}/reports/{{reportUuid}}',
    postReport: '/backoffice/business-intelligence/{{version}}/reports',
    patchReport: '/backoffice/business-intelligence/{{version}}/reports/{{reportUuid}}',
    deleteReport: '/backoffice/business-intelligence/{{version}}/reports/{{reportUuid}}',
    getRealTimestamp: '/api/business-intelligence/get-real-timezone',
};
